import React from "react";
import IconButton from "material-ui/IconButton";
import PropTypes from "prop-types";

export default class IconBtn extends React.Component {
    handleKeyDowm = e => {
        if (e.keyCode === 13) {
            this.props.onClick(e);
        }
    };

    render() {
        return <IconButton {...this.props} onKeyDown={this.handleKeyDowm} />;
    }
}

IconBtn.propTypes = {
    onClick: PropTypes.func
};

IconBtn.defaultProps = {
    onClick: () => {}
};
